export default "__VITE_ASSET__ef767ca4__"